<template>
  <div class="main-tabs-content">

  <div class="ticket_details_page"> 
      <div class="ticket_details d-flex justify-between">
         <!-- {{ticket.statusDetails}} -->      
         <div class="ticket_desc_left"> 
          <h3>{{checkProperty(ticket ,'subject')}}            
            <span> {{checkProperty(ticket ,"priorityDetails" ,'name') }}   </span>  
            <span 
  
            v-bind:class="{
                      'status_created': checkProperty(ticket ,'statusDetails','id') == 1,
                      'status_assigned': checkProperty(ticket ,'statusDetails','id') == 2,
                      'status_inProcess': checkProperty(ticket ,'statusDetails','id') == 3,
                      'status_feedback': checkProperty(ticket ,'statusDetails','id') == 4,
                      'status_notAnIssue': checkProperty(ticket ,'statusDetails','id') == 5,
                      'status_onHold': checkProperty(ticket ,'statusDetails','id') == 6,
                      'status_resolved': checkProperty(ticket ,'statusDetails','id') == 7,
                      'status_rejected': checkProperty(ticket ,'statusDetails','id') == 8,
                      'status_duplicate': checkProperty(ticket ,'statusDetails','id') == 9,
                      'status_closed': checkProperty(ticket ,'statusDetails','id') == 10,
                      
                    }"
            
            
  
             >{{checkProperty(ticket ,'statusDetails' ,'name')}}</span>    
          </h3>
          
         
        <p v-html="checkProperty(ticket ,'description')"> </p>
        <label>Created By <a >{{checkProperty(ticket ,'createdByName')}}</a> On 
        <a>
          <template v-if="checkProperty(ticket ,'createdOn')">
          {{checkProperty(ticket ,'createdOn') | formatDateTime}}.
          </template>
        </a>
        <template v-if="checkProperty(ticket ,'updatedOn')">
          Last Updated On  <a>{{checkProperty(ticket ,'updatedOn') | formatDateTime}}.</a>
      </template>
       
        </label>
        <!-- <label>Assignee changed from <a>Ravi Kumar Vadde</a> to <a>rohitha pusapati</a></label> -->
       <!--
        <ul>
          <li><h6>Priority</h6><span>Text</span></li>
          <li><h6>Case Type</h6><span>Text</span></li>
          <li><h6>Device Family</h6><span>Text</span></li>
          <li><h6>Version</h6><span>Text</span></li>
          <li><h6>Area</h6><span>Text</span></li>
          <li><h6>Project</h6><span>Text</span></li>
          <li><h6>Assigned To </h6><span>Text</span></li>
        </ul>
        --> 
         <ul class="uploaded-files" v-if="checkProperty(ticket ,'attachments', 'length') > 0  "> 
          <template v-for="(tattachment ,atIndex ) in ticket['attachments']" >
            
            <template v-if="checkFileFormat(tattachment['mimetype']) =='video_mime_types'">
              <li :key="atIndex" @click="downloadfile(tattachment)"  v-tooltip.top-center="checkProperty(tattachment ,'name') " > 
                <figure>
                  <img src="@/assets/images/main/film.png" />
                  <span class="download_icon"></span>  
                </figure> 
                <!-- <p>{{checkProperty(tattachment ,"name")}}</p> -->
                
              </li>
            
            </template>
            <template v-else-if="checkFileFormat(tattachment['mimetype']) =='pdf'">
              <li :key="atIndex" @click="downloadfile(tattachment)"  v-tooltip.top-center="checkProperty(tattachment ,'name') "> 
                <figure>
                  <img src="@/assets/images/main/pdf.svg" />
                  <span class="download_icon"></span>  
                </figure>  
                
              </li>
            
            </template>
            <template v-else-if="checkFileFormat(tattachment['mimetype']) =='msDoc'">
              <li :key="atIndex" @click="downloads3file(tattachment)" v-tooltip.top-center="checkProperty(tattachment ,'name') "> 
                <figure>
                  <img src="@/assets/images/main/doc.svg" />
                  <span class="download_icon"></span>  
                </figure>  
                
              </li>
            
            </template>
            <template v-else-if="checkFileFormat(tattachment['mimetype']) =='msXl'">
              <li :key="atIndex" @click="downloads3file(tattachment)" v-tooltip.top-center="checkProperty(tattachment ,'name') " > 
                <figure>
                  <img src="@/assets/images/main/xls.svg" />
                  <span class="download_icon"></span>  
                </figure> 
                <p>{{checkProperty(tattachment ,"name")}}</p>
                
              </li>
            
            </template>
            <template v-else-if="checkFileFormat(tattachment['mimetype']) =='msPpt'">
            <li :key="atIndex" @click="downloads3file(tattachment)" v-tooltip.top-center="checkProperty(tattachment ,'name') " > 
              <figure>
                <img src="@/assets/images/main/ppt.svg" />
                <span class="download_icon"></span>  
              </figure> 
               
              
            </li>
          
            </template>
            <template v-else-if="checkFileFormat(tattachment['mimetype']) =='zip'">
              <li :key="atIndex" @click="downloads3file(tattachment)"  v-tooltip.top-center="checkProperty(tattachment ,'name') "> 
                <figure>
                  <img src="@/assets/images/main/zip-file-format.png" />
                  <span class="download_icon"></span>  
                </figure> 
                
                
              </li>
            
            </template>
            <template v-else-if="checkFileFormat(tattachment['mimetype']) =='image'">
              <li :key="atIndex" @click="downloads3file(tattachment)"  v-tooltip.top-center="checkProperty(tattachment ,'name') "> 
                <figure>
                  <img src="@/assets/images/main/image.svg" />
                  <span class="download_icon"></span>  
                </figure> 
               
                
              </li>
            
            </template>
            <template v-else>
              <li :key="atIndex" @click="downloads3file(tattachment)" v-tooltip.top-center="checkProperty(tattachment ,'name') "> 
                <figure>
                  <img src="@/assets/images/main/commonfiles.png" />
                  <span class="download_icon"></span>  
                </figure> 
              </li>
            
            </template>

            
          </template>
        </ul>
         
      <!--
        <ul class="uploaded-files">
          
            <li> 
              <figure>
                <img src="@/assets/images/main/doc.svg" />
                <span class="download_icon"></span>  
              </figure> 
              <p>File Title File Title File Title File Title</p>
              
            </li>
            <li>
              <figure>
                <img src="@/assets/images/main/image.svg" />
                <span class="download_icon"></span>    
              </figure>  
              <p>File Title</p>
            </li>
            <li>
              <figure>
                <img src="@/assets/images/main/pdf.svg" />
                  <span class="download_icon"></span>  
                </figure>  
                <p>File Title</p>
            </li>
            <li>
              <figure><img src="@/assets/images/main/ppt.svg" />
                <span class="download_icon"></span>  
              </figure>  
              <p>File Title</p>
            </li>
            <li>
              <figure><img src="@/assets/images/main/xls.svg" />
                <span class="download_icon"></span>  
              </figure>  
              <p>File Title</p>
            </li>
             <li>
              <figure><img src="@/assets/images/main/film.png" />
                <span class="download_icon"></span>  
              </figure>  
              <p>File Title</p>
            </li>
             <li>
              <figure><img src="@/assets/images/main/zip-file-format.png" />
                <span class="download_icon"></span>  
              </figure>  
              <p>File Title</p>
            </li>
             <li>
              <figure><img src="@/assets/images/main/commonfiles.png" />
                <span class="download_icon"></span>  
              </figure>  
              <p>File Title</p>
            </li>
          
        </ul>
        -->
        </div>
        <div class="d-flex ticket-right">
          <div class="ticket_actions">
            <!-- <button v-if="ticket.createdBy !=this.getUserData['userId']" class="post_btn primary-btn" @click="formerrors.msg='';selected_user=null;assignmentPopUp=true" > Assign</button> -->
            <button class="post_btn primary-btn" v-if="checkProperty(ticket ,'statusDetails' ,'id') != 10"  @click="formerrors.msg='';selected_user=null;assignmentPopUp=true" > Assign</button>
          </div>
          <div class="assign_history_wrap" v-if="checkProperty(ticket['assignedToHistory'], 'length') > 0">
              Currently Assigned to <a>{{checkProperty(ticket['assignedToHistory'][0], 'assignedToName' )}}</a>
               <div class="peoples_list">
                  <figure class="people_dp ">                      
                    <img class="file-icon" src="@/assets/images/main/history_icon.svg" /> 
                  </figure>
                  <div class="dropdown">                      
                    
                      <div class="peoples-detailes-wrap">   
                        <VuePerfectScrollbar    class="scroll-area--main-sidebar" :settings="settings"   >                     
                        <ul class="peoples-detailes-dropdown">
                        <template v-for="(item,index ) in ticket['assignedToHistory']">
                          <li :key="index" class="peoples-detailes_cnt" >
                            <figure>
                              <img v-if="checkProperty(item ,'assignedToprofilePicture')" :src="checkProperty(item ,'assignedToprofilePicture')" @error="setDefaultPhoto">
                              <span v-else style="text-transform: uppercase;">{{checkProperty(item,'assignedToName') | getTwolatters}}</span> 
                            </figure>
                            <div class="people-content">
                                <h5>{{checkProperty(item,'assignedToName')}}</h5>
                                <h6 v-if="checkProperty(item ,'assignedOn')">Last Assigned {{item.assignedOn | formatDate}}</h6>
                              </div>
                            </li>
                           
                            </template>
                        </ul>
                        </VuePerfectScrollbar>
                      </div> 
                    
                  </div>
                
                <!-- <div class="tooltip_cnt"><p>Watcher(s)</p></div> -->
              </div>
          </div> 
        </div>      
      </div>
      <div class="ticket_conversation">
     
        <div class="write_post"  > 
          <!-- <vs-textarea @click="showCommentError=false" @keyup="showCommentError=false" placeholder="Comments"  v-model="CommentPayload.description" /> -->
          <ckeditor @click="showCommentError=false" @keyup="showCommentError=false" placeholder="Comments"  v-model="CommentPayload.description"  :editor="editor" :config="editorConfig"></ckeditor>
          <div class="write_post_actions" @click="value=[]">
          
              <vs-checkbox v-model="commentType"  v-if="getUserRoleId !=12 && getUserRoleId !=13" >Internal</vs-checkbox>
              <!-- @input="upload(value)" -->
              <file-upload v-model="value" class="file-upload-input upload_file" 
                :accept="allDocEntity" @updateData="updateData"
                    :name="'Documents'" :multiple="true" :hideSelected="true" 
              >
                <p>
                  <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                  Upload </p>
                  <span v-if="uploading" class="loader bod-radius0"><img src="@/assets/images/main/loader.gif"></span>
              </file-upload>
                 
               <!-- <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif"></span>    -->
              
               <div>
                <multiselect
              v-model="selected_statusids"
              :options="support_status"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Select Status"
              label="name"
              track-by="name"
              :preselect-first="false"
              @input="checkSelecteStatus"
              :allow-empty="false"
              :disabled="checkProperty(ticket ,'statusDetails' ,'id')==10"
              
            >
            <!-------:disabled="ticket.createdBy ==this.getUserData['userId']"-->
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} options selected</span>
              </template>
                </multiselect>
                </div>
              <button class="post_btn primary-btn"  @click="supportTicketsCreateComment()">Update</button>
          </div> 
          <span class="text-danger text-sm" v-if="showCommentError" >Comments are required </span>
          <ul class="uploaded_files" v-if="checkProperty(CommentPayload ,'attachments') && CommentPayload['attachments'].length > 0" >
            <template v-for=" ( attachment, attIndex) in CommentPayload['attachments'] " >
            <li :key="attIndex"   >  
            
              <p>{{checkProperty(attachment,'name')}}</p>
              <img  class="remove-icon" src="@/assets/images/main/cross.svg" @click="remove( attIndex)" />
            </li>
            </template>
            
           
          </ul>
        </div>
        <div class="conversation_list_wrap" v-if="ticketComments.length > 0">
          
          <template v-for="( comment , comIndx) in ticketComments "  >
            <div class="conversation_list" :key="comIndx">
              <!-- <figure><img src="@/assets/images/main/user-icon.png" /></figure> -->
              <div>
            
                <!-- <h4>
                {{checkProperty(comment,'createdByDetails' ,'name')}}
                  <span v-if="checkProperty(comment,'commentTypeId') ==2">Internal
                  </span>
                </h4> -->
                <p v-html="checkProperty(comment ,'description')"> </p>
                <span>Updated By <a>{{checkProperty(comment,'createdByDetails' ,'name')}}</a> On <a>{{comment['createdOn'] | formatDateTime}}</a></span><br>
                <span class="status-postion-left" v-if="checkProperty(comment ,'statusDetails','name')"
                v-bind:class="{
                    'status_created': checkProperty(comment ,'statusDetails','id') == 1,
                    'status_assigned': checkProperty(comment ,'statusDetails','id') == 2,
                    'status_inProcess': checkProperty(comment ,'statusDetails','id') == 3,
                    'status_feedback': checkProperty(comment ,'statusDetails','id') == 4,
                    'status_notAnIssue': checkProperty(comment ,'statusDetails','id') == 5,
                    'status_onHold': checkProperty(comment ,'statusDetails','id') == 6,
                    'status_resolved': checkProperty(comment ,'statusDetails','id') == 7,
                    'status_rejected': checkProperty(comment ,'statusDetails','id') == 8,
                    'status_duplicate': checkProperty(comment ,'statusDetails','id') == 9,
                    'status_closed': checkProperty(comment ,'statusDetails','id') == 10,
                    
                  }"
                >{{checkProperty(comment ,'statusDetails','name')}}</span>
                <!--
                <ul class="uploaded_files"  v-if="checkProperty(comment ,'attachments') && comment['attachments'].length>0" >
                <template v-for="(cattchments ,atIndx) in comment['attachments'] ">
                  <li :key="atIndx"  @click="downloadfile(cattchments)">
                    <p>{{checkProperty(cattchments,'name')}}</p>
                    <img  class="download-icon" src="@/assets/images/main/download.svg" />
                  </li>
                </template>  
                  
                </ul>
                -->

                <ul class="uploaded-files" v-if="checkProperty(comment ,'attachments')" >
                      <template v-for="(cattachment ,catIndex ) in comment['attachments']" >

                            <template v-if="checkFileFormat(cattachment['mimetype']) =='video_mime_types'">
                              <li :key="catIndex" @click="downloads3file(cattachment)"   v-tooltip.top-center="checkProperty(cattachment ,'name')"> 
                              <figure>
                              <img src="@/assets/images/main/film.png" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}}</p> -->

                              </li>

                            </template>
                            <template v-else-if="checkFileFormat(cattachment['mimetype']) =='pdf'" v-tooltip.top-center="checkProperty(cattachment ,'name')">
                              <li :key="catIndex" @click="downloads3file(cattachment)"  > 
                              <figure>
                              <img src="@/assets/images/main/pdf.svg" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}}</p> -->

                              </li>

                            </template>
                            <template v-else-if="checkFileFormat(cattachment['mimetype']) =='msDoc'" v-tooltip.top-center="checkProperty(cattachment ,'name')">
                              <li :key="catIndex" @click="downloads3file(cattachment)" > 
                              <figure>
                              <img src="@/assets/images/main/doc.svg" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}}</p> -->

                              </li>

                            </template>
                            <template v-else-if="checkFileFormat(cattachment['mimetype']) =='msXl'" v-tooltip.top-center="checkProperty(cattachment ,'name')">
                              <li :key="catIndex" @click="downloads3file(cattachment)" > 
                              <figure>
                              <img src="@/assets/images/main/xls.svg" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}}</p> -->

                              </li>

                            </template>
                            <template v-else-if="checkFileFormat(cattachment['mimetype']) =='msPpt'" v-tooltip.top-center="checkProperty(cattachment ,'name')">
                              <li :key="catIndex" @click="downloads3file(cattachment)" > 
                              <figure>
                              <img src="@/assets/images/main/ppt.svg" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}}</p> -->

                              </li>

                            </template>
                            <template v-else-if="checkFileFormat(cattachment['mimetype']) =='zip'" v-tooltip.top-center="checkProperty(cattachment ,'name')">
                              <li :key="catIndex" @click="downloads3file(cattachment)" > 
                              <figure>
                              <img src="@/assets/images/main/zip-file-format.png" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}}</p> -->

                              </li>

                            </template>
                            <template v-else-if="checkFileFormat(cattachment['mimetype']) =='image'" v-tooltip.top-center="checkProperty(cattachment ,'name')">
                              <li :key="catIndex" @click="downloads3file(cattachment)" > 
                              <figure>
                              <img src="@/assets/images/main/image.svg" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}}</p> -->

                              </li>

                            </template>
                            <template v-else>
                              <li :key="catIndex" @click="downloads3file(cattachment)" v-tooltip.top-center="checkProperty(cattachment ,'name')"> 
                              <figure>
                              <img src="@/assets/images/main/commonfiles.png" />
                              <span class="download_icon"></span>  
                              </figure> 
                              <!-- <p>{{checkProperty(cattachment ,"name")}} {{cattachment['mimetype']}}</p> -->

                              </li>

                            </template>


                      </template>
                  </ul>
              </div>
            
            </div> 
          </template>        
      </div>
  </div>
   
  </div>

  
 <vs-popup class="holamundo main-popup" title="Assign" v-if="assignmentPopUp" :active.sync="assignmentPopUp">
      <form>
        <div class="form-container pb-0">
          <!-- <div class="vx-row"></div> -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
                <div class="con-select w-full select-large">
                  <label class="form_label">Users</label>
                  <multiselect
                      v-model="selected_user"
                      :options="assigneeUserList"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select User"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span>
                      </template>
                    </multiselect>
                </div>
              </div>
              
              
            </div>

          </div>
          


          <div class="text-danger text-sm formerrors" v-show="formerrors.msg" @click="formerrors.msg=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer">
          <vs-button color="dark" @click="assignmentPopUp =false; resetComment()" class="cancel" type="filled">Cancel</vs-button>
          <vs-button color="success" :disabled="selected_user==null"  class="save" @click="assgnment()" type="filled">Submit</vs-button>
        </div>
      </form>
    </vs-popup>

  </div>
</template>
<script>
import moment from "moment";
//import JQuery from "jquery";
//import FileUpload from "vue-upload-component/src";
//import Multiselect from "vue-multiselect-inv";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import FileUpload from "@/views/FileUpload.vue";

Vue.use(VTooltip)
 
export default {
  components: {
    FileUpload, 
    //VTooltip,
     VuePerfectScrollbar
    //Multiselect
  },
  name: "app",
  data: () => ({
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
     showCommentError:false,
    msg: 'This is a button.',
    assigneeUserList:[],
    uploading:false,
    commentType:false,
    assignmentPopUp:false,
    formerrors: {
        msg: ""
      },
      settings: { 
        swipeEasing: false,
      },
    selected_statusids:null,
     value:[],
      AddNewTicketComment:false,
    loaded:false,
    currentRole: null,
    currentUserId:null,
    SuccessQuestionnaire: false,
    ticket: null,
    ticketComments:[],
    support_status: [],
    users:[],
    selected_user:null,
    CommentPayload: {
        "ticketId": "",
        "statusId": '',
        "description": "",
        "attachments": [],
        "today": moment().format('YYYY-MM-DD')
    },
    all_user_roles:[],
    selected_role:'',
    selectedAssignTouser:null,
  }),
  watch: {
 
  },
  methods: {
    updateData(docs){
      this.CommentPayload.attachments = docs
    },
    init(){
        this.reloadTicket();
        this.getTicketStatusList();
        //user_roles
        this.$store.dispatch("getmasterdata", "user_roles").then(response => {
        this.all_user_roles = response;
        });
        this.getticketAssigneeUsers();
    },
    getticketAssigneeUsers(){
      let postData = { "ticketId":this.$route.params.itemId };
       this.$store.dispatch("commonAction", {"data":postData ,"path":"/support-tickets/get-assign-users"})
              .then(response => {
               this.assigneeUserList =response
                /*
                if( response && response.length>0){
                  let obj ={
                    roleIds:response.map((item,)=>{return item['roleId'] }),
                    getMasterData:true,
                    getAll:true,
                    "page": 1,	
                    "perpage":100000000,
                  }
                   this.$store.dispatch("getList",{data:obj ,path:'/users/list'} )
                    .then(response => {
                      //alert(JSON.stringify(response.list));
                      let lst = response.list
                      
                      this.assigneeUserList= lst.map((item)=>{
                        item.name = item.name+" ("+item.roleName+")";
                        return item;

                      });
                      
                      

                    });

                }
                */
               
              })
    },
    checkSelecteStatus(item){
      
     
      if(_.has(this.ticket ,'statusId') && this.ticket['statusId'] >1  && ( item && item['id']==1)){

       

           this.selected_statusids = _.find( this.support_status , {"id":this.ticket["statusId"]});
         
      }else{
        this.selected_statusids =item;
      }
       if(this.selected_statusids && this.ticket["statusId"] != this.selected_statusids['id']){
        // let postData = {  ticketId:this.ticket['_id'], "statusId": this.selected_statusids['id'], "statusName":this.selected_statusids['name']};
        // this.$store.dispatch("commonAction", {"data":postData ,"path":"/support-tickets/update-status"})
        //       .then((response) =>{
                  
        //            this.showToster({"message":response.message , isError:false});
        //            this.init();
                  
        //           }).catch((error)=>{
        //              this.showToster({"message":error , isError:true})
                  
                 
        //           })
        }

    },

     downloadfile(value) {
     
     if(_.has(value  ,"path")){
       value = Object.assign(value ,{ "url": value['path']})
     }
     if(_.has(value  ,"url")){
       value = Object.assign(value ,{ "path": value['url']})
     }
      value.url = value.path.replace(this.$globalgonfig._S3URL,"");
      value.url = value.path.replace(this.$globalgonfig._S3URLAWS,"");
      let postdata = { keyName: value.path };
      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        window.open(response.data.result.data, "_blank");
      });
    },
    chengedUserRole(){
     // alert(JSON.stringify(this.selected_role));
      this.getUsers(this.selected_role['id']);
    },

assgnment(){
 this.formerrors.msg = '';
   
 
   let payLoad ={
     ticketId:this.ticket['_id'],
     assignedTo:this.selected_user['_id'],
     assignedToName:this.selected_user['name'],
     assignedToRoleId:this.selected_user['roleId'],
     assignedToRoleName:this.selected_user['roleName']

   };

    this.$store.dispatch("supportTicketsAssign" ,payLoad)
    .then((response)=>{
         this.assignmentPopUp =false;
         this.$vs.notify({
                title: "Success",
               position:'top-right',
               color:'success',
               iconPack: 'feather',
               icon:'icon-check',
                text: response.message
              });
         this.reloadTicket();
        })
        .catch((err)=>{
            //alert(JSON.stringify(err));
            this.formerrors.msg =err
        });
    

},
  supportTicketsCreateComment(){
     this.formerrors.msg ='';
     this.showCommentError =false;
     this.CommentPayload['statusId'] = this.ticket['statusId'];
     
     let postdata =  this.CommentPayload;
     if(this.commentType){
       postdata = Object.assign(postdata,{"commentTypeId":2})
     }

     if(this.selected_statusids && _.has(this.selected_statusids ,"id")){
       postdata['statusId'] =  this.selected_statusids['id'];
     }
     
     if(!this.CommentPayload.description.trim()){
     
       this.showCommentError =true;
       
     }
    

     if(!this.showCommentError){
    this.$store.dispatch("supportTicketsComment" ,postdata)
    .then((response)=>{
         this.AddNewTicketComment =false;
         this.commentType =false;
         this.$vs.notify({
                title: "Success",
               position:'top-right',
               color:'success',
               iconPack: 'feather',
               icon:'icon-check',
                text: response.message
              });
         this.reloadTicket();
        })
        .catch((err)=>{
            //alert(JSON.stringify(err));
            this.formerrors.msg =err
        });
    
  }
  
  },
    upload(model) {

            var _current = this;
            //this.$vs.loading();
            
            let efiles = [];
            efiles = _.filter(model, (e) => { return (e.url !=null && e.url !='') });
            let nfiles = _.filter(model, (e) => { return (e.url ==null || e.url ==undefined )});

            let mapper = nfiles.map(
                (item) =>
                (item = {
                    name: item.name,
                    file: item.file ? item.file : null,
                    url: item.url ? item.url : "",
                    path: item.path ? item.path : "",
                    status: item.status === false || item.status === true ?
                        item.status : true,
                    mimetype: item.type ? item.type : item.mimetype,
                    uploadedBy:this.checkProperty(this.getUserData,'userId'),
                    uploadedByName:this.checkProperty(this.getUserData,'name'),
                    uploadedByRoleId:this.getUserRoleId,
                    uploadedByRoleName:this.checkProperty(this.getUserData,'loginRoleName'),
                })
            );
            if (mapper.length > 0) {
              this.uploading = true;
                mapper.forEach((doc, index) => {
                  let formData = new FormData();
                    formData.append("files", doc.file);
                    formData.append("secureType", "private");
                    formData.append("getDetails", true);
                    
                    this.$store.dispatch("uploadS3File", formData).then((response) => {
                        response.data.result.forEach((urlGenerated) => {
                         // alert(JSON.stringify(urlGenerated))
                          this.CommentPayload.attachments.push(urlGenerated)
                            doc.url = urlGenerated['path'];
                            doc.path = urlGenerated['path'];
                            delete doc.file;
                            mapper[index] = doc;
                        });
                    if (index >= mapper.length - 1) {
                       this.uploading = false;
                        //_current.$vs.loading.close();
                    }
                    });
                
                });
               if(efiles.length > 0) efiles.push(...mapper)
                //this.CommentPayload["attachments"] = efiles
              
            }
        },
     remove(index) {
         this.CommentPayload.attachments.splice(index, 1);
           
        },
    resetComment(){
    this.CommentPayload= {
        "ticketId": this.$route.params.itemId,
        "statusId": this.ticket['statusId'],
        "description": "",
        "attachments": [],
        "today": moment().format('YYYY-MM-DD')
    }
    },
    reloadTicket(){
      this.CommentPayload = {
        "ticketId": "",
        "statusId": '',
        "description": "",
        "attachments": [],
        "today": moment().format('YYYY-MM-DD')
    };
    this.selected_user =null;
    this.CommentPayload["ticketId"] =  this.$route.params.itemId;
    this.loadTicket(this.$route.params.itemId);
    this.loadTicketComments(this.$route.params.itemId);
    
    },
    
    loadTicket(ticketId) {
      this.loaded = false;
      this.$store.dispatch("supportTickesDetails", {"ticketId":ticketId}).then(response => {
        
        this.ticket = response;
        this.getTicketStatusList();
       
    })
    .catch((err)=>{
      
       this.showToster({message:err.message ,isError:true});


    });
    },

    loadTicketComments(ticketId) {
      this.loaded = false;
      this.$store.dispatch("supportTickeCommentList", { ticketId:ticketId}).then(response => {
      this.ticketComments = response;
       
    })
    .catch((err)=>{
       // alert(JSON.stringify(err));
        this.showToster({message:err.message ,isError:true});


    });
    },
     getUsers(roleId='') {

         this.$store.dispatch("getusersByrole", roleId).then(response => {
      this.users = response.list;
    });
      },

      //selected_statusids
      getTicketStatusList(){
         this.$store.dispatch("getmasterdata", "support_status").then(response => {
         this.support_status = response;
         this.support_status = this.support_status.map(function(item) { 
                 
                  
                    
                  
                   delete item._id;
                   return item;  
                  
        });
         if(this.ticket  && _.has(this.ticket ,"statusId")){

           this.selected_statusids = _.find( this.support_status , {"id":this.ticket["statusId"]});
         }

          this.support_status = _.filter(this.support_status ,(item)=>{
            return item['id'] !=1 && item['id'] !=2;
          })
       });


      },

      
  
  },

    beforeDestroy() {
             
    },
  mounted() {
    this.currentRole = this.$store.state.user.loginRoleId;
    this.currentUserId = this.$store.state.user._id;
     this.init();
    
  }
};
</script>
